<template>
    <div class="emailmarket-box">
        <div class="market-box">
            <h3 class="caption">{{marketData.caption}}</h3>
            <DoBetter :childModle='marketData.childModleData' class="itemtwo"></DoBetter>
        </div>
    </div>
</template>
<script>
    import DoBetter from '@/components/main/contact/dobetter'//引入说明
    export default {
        name: 'EmailMarket',
        data() {
            return {
                marketData: {
                    caption: '邮件营销 - 激活潜在客户 ...',
                    childModleData: {//DoBetter 子模块的数据
                        center: '我们运用全球最领先的邮件营销工具，帮助外贸企业激活老客，开发潜在新客。<br/>邮件营销也是针对小型企业的最具成本效益的营销策略之一。<br/>据美国直销协会称，邮件营销平均为美国企业带来4300％的投资回报率。<br/>这是因为电子邮件营销易于管理，可以完全控制并允许您与客户建立直接的联系。',
                        title: 'Email',
                        showdown: 'Marketing',
                        caption: 'Do Better.'
                    },
                }
            }
        },
        components: {
            DoBetter,
        }
    }
</script>
<style scoped>
    .emailmarket-box {
        padding: 181px 0 0 263px;
        background-color: #ffffff;
        height: auto;
    }

    .market-box {
        height: 100%;
        background-color: #F1F1F1;
        position: relative;
    }

    .caption {
        font-family: gilroybold4;
        max-width: 448px;
        font-size: 40px;
        font-weight: bold;
        line-height: 122%;
        color: rgba(28, 28, 28, 1);
        text-transform: uppercase;
        transform: translate(-15%,0);
    }

    /* 引入的样式 */
    .DoBetter>>>.wecat {
        display: none;
    }

    .DoBetter>>>.center-box {
        width: 1141px;
        height: 777px;
        padding-left: 249px;
    }

    .DoBetter>>>.center-box::after {
        width: 575px;
        height: 737px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/8259019d3ef70c373be081e011404779.jpg') no-repeat center;
        top: 137px;
        right: -530px;
    }

    .DoBetter>>>.animetionLine,
    .emailmarket-box>>>.DoBetter::before {
        display: none;
    }

    .DoBetter>>>.center-box::before {
        content: 'college';
        transform: rotate(90deg) translate(22%, -115px);
    }

    .DoBetter>>>.title-caption {
        font-size: 42px;
        font-weight: bold;
        line-height: 59px;
        color: #FFFFFF;
        position: relative;
        margin-bottom: 44px;
    }

    .DoBetter>>>.showdown {
        font-size: 42px;
        color: #1C1C1C;
        font-family: gilroybold4;
        font-weight: bold;
        -webkit-text-stroke: 1px rgba(229, 229, 229, 1);
        text-stroke: 1px rgba(229, 229, 229, 1);
    }

    .itemtwo>>>.center-box {
        width: 63%;
        height: 664px;
        padding:10%;
        background-color: #1C1C1C;
    }

    .itemtwo>>>.center-box::after {
        position: absolute;
        content: '';
        display: block;
        width: 98%;
        height: 688px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/photo-1557200134-90327ee9fafa.jpg') no-repeat center;
        background-size: cover;
        top:-15%;
        right:-84%;
    }

    .emailmarket-box .itemtwo {
        padding: 0px 0 0px 0;
        position: relative;
        bottom: 0;
        transform: translateX(-263px);

    }

    .itemtwo>>>.title-caption::before {
        content: '邮件营销';
        display: block;
        text-transform: uppercase;
        position: absolute;
        top: 0;
        left: 0;
        white-space: nowrap;
        color: rgba(36, 136, 248, 1);
        transform: translateY(-150%);
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        color: rgba(36, 136, 248, 1);
    }

    .itemtwo>>>.center-caption {
        right: 0;
        transform: translateY(-68%);
        display: none;
    }

    .itemtwo>>>.center-caption::after,
    .itemtwo>>>.center-box::before {
        display: none;
    }

    .itemtwo>>>.text-center {
        max-width: 581px;
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        color: rgba(255, 255, 255, 1);
    }
    @media(max-width: 1440px){
        .caption {
        max-width: 280px;
        font-size: 24px;
        transform: translate(-50%,0);
    }
    }
    @media(max-width: 995px){
        .emailmarket-box {
        padding:0%;
    }
        .itemtwo>>>.center-box::after {
        display: none;
    }
    .emailmarket-box .itemtwo {
        transform: translateX(0px);
    }
    .itemtwo>>>.center-box {
        width:100%;
        height: auto;
        padding:5%;
        min-height: auto;
        justify-content: center;
        background-color: #1C1C1C;
    }
    .itemtwo>>>.text-center {
        max-width: 100%;
        line-height: 175%;
        background-color: #1C1C1C;
        padding: 0;
    }
    .caption {
        display: none;
    }
    .DoBetter>>>.title-caption {
        font-size: 24px;
        line-height: 140%;
        margin-bottom: 0%;
    }

    .DoBetter>>>.showdown {
        font-size: 24px;
    }
    .itemtwo>>>.title-caption::before {
        position: static;
        transform: translateY(0%);
        font-size: 24px;
        line-height: 137%;
    }
    }

    /* @media(max-width: 1023px) {
        .emailmarket-box {
            height: 1600px;
        }

        .caption {
            max-width: 49%;
            font-size: 72px;
            line-height: 122.5%;
            transform: translate(-20%, 20%);
        }

        .DoBetter>>>.center-box::after {
            display: none;
        }

        .emailmarket-box .itemtwo {
            width: 100%;
            height: 80%;
            position: absolute;
            transform: translateX(-10%);
        }

        .itemtwo>>>.center-box {
            width: 100%;
            height: 100%;
            padding-left: 150px;
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/photo-1557200134-90327ee9fafa.jpg') no-repeat center;
            background-attachment: initial;
            background-size: cover;
        }

        .DoBetter>>>.title-caption {
            font-size: 85px;
            line-height: 140%;
            margin-bottom: 0;
        }

        .itemtwo>>>.title-caption::before {
            font-size: 50px;
        }

        .DoBetter>>>.showdown {
            font-size: 85px;
        }

        .itemtwo>>>.text-center {
            transform: translateY(0);
            max-width: 100%;
            font-size: 50px;
            line-height: 150%;
            color: #1C1C1C;
        }
    }
    @media(max-width: 350px){
        .emailmarket-box {
            height: 2100px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/emailmarketing.vue